import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetSampleAttachmentsResponse } from "./type";

async function getSampleAttachmentsById(
  sampleId: string,
  query: GetQueries,
): Promise<GetSampleAttachmentsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.samples.getAttachments(sampleId);
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetSampleAttachmentsResponse>(url);

  return response.data;
}

export function useGetSampleAttachments(
  sampleId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-sample-attachments-${sampleId}`, JSON.stringify(query ?? {})],
    () => getSampleAttachmentsById(sampleId, query ?? {}),
    mergedOptions,
  );
}
